import { useTranslation } from "react-i18next";

import { HookFormInput } from "@/components_v2/FormFields/ReactHookForm/fields";
import FormFieldWrapper from "@/components_v2/Wrapper/FormFieldWrapper";
import BaseButton from "@/components_v2/Button/BaseButton";
import { EmailStepProps } from "../types";

const EmailStep = ({
  form,
  hasNoMatchingOrganization,
  isCheckingEmail,
  handleNext,
}: EmailStepProps) => {
  const { t } = useTranslation();
  const email = form.watch("email");

  const isContinueDisabled = !email?.trim() || isCheckingEmail;

  return (
    <div className="flex flex-col gap-400">
      <div className="flex flex-col gap-200">
        <h2 className="apply-to-join__title header-m-medium">
          {hasNoMatchingOrganization
            ? t("applications.labels.verifyWorkEmailTitle")
            : t("applications.labels.enterWorkEmailTitle")}
        </h2>
        <p className="apply-to-join__description body-m-regular">
          {t("applications.labels.enterWorkEmailDescription")}
        </p>
      </div>

      <FormFieldWrapper label={t("applications.labels.email")} required>
        <HookFormInput
          name="email"
          placeholder={t("applications.placeholders.enterWorkEmail")}
          control={form.control}
        />
      </FormFieldWrapper>

      {hasNoMatchingOrganization && (
        <div
          className="apply-to-join__error-box flex flex-col gap-200"
          role="alert"
          aria-live="polite"
        >
          <p className="apply-to-join__error-title body-m-medium">
            {t("applications.labels.noOrganizationFoundTitle")}
          </p>
          <p className="apply-to-join__error-description body-m-regular">
            {t("applications.labels.noOrganizationFoundDescription")}
          </p>
        </div>
      )}

      <div className="flex flex-col items-center full-width">
        <BaseButton
          isFullWidth
          disabled={isContinueDisabled}
          loading={isCheckingEmail}
          onClick={handleNext}
        >
          {t("applications.labels.continue")}
        </BaseButton>
      </div>
    </div>
  );
};

export default EmailStep;
